<app-navbar></app-navbar>
<div  class="card" style="padding: 20px; background-image: url('assets/img/school/bg.png');
 background-color: #005a63; background-size: 100px; background-attachment: fixed;">
 <h2 style=" text-align: center; margin-bottom: 10px;">Videos</h2>
 <br ><br >
 <div class="container" style="text-align: justify !important;">
  <div class="row">
    <div  class="col-md-12">
      <div class="card">
        <div  class="card-body text-justify">
          <div  class="folder mb-3">
            <a  href="/videoFolder/1323">
              <i  aria-hidden="true" class="fa fa-folder">

              </i>
              <p >Video Folder</p>
            </a>
          </div>
          <!-- <div  class="folder mb-3">
            <a  href="/imageFolder/1319">
              <i  aria-hidden="true" class="fa fa-folder"></i>
              <p >Bijoy Mela </p></a>
            </div>
            <div  class="folder mb-3">
                <a  href="/imageFolder/1320">
                  <i aria-hidden="true" class="fa fa-folder"></i>
                  <p >International Disabilities Day </p></a>
                </div>
                <div class="folder mb-3">
                    <a  href="/imageFolder/1321">
                      <i _ngcontent-vsw-c24="" aria-hidden="true" class="fa fa-folder">
                    </i>
                    <p >Sheikh Rasel Day </p></a></div><div _ngcontent-vsw-c24="" class="folder mb-3">
                      <a  href="/imageFolder/1322">
                      <i aria-hidden="true" class="fa fa-folder"></i>
                      <p >Tree Plantation 2023 </p></a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

